var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.steps.length
    ? _c(
        "div",
        { staticClass: "row mb-3" },
        _vm._l(_vm.steps, function(step, index) {
          return _c("div", { key: "step-" + index, staticClass: "col-3" }, [
            _c("div", { staticClass: "step-wrapper" }, [
              _c("span", { staticClass: "step-number" }, [
                _vm._v(_vm._s(step.stepNumber))
              ]),
              _c(
                "span",
                { staticClass: "step-delete" },
                [
                  _c("vs-icon", {
                    attrs: {
                      icon: "highlight_off",
                      size: "small",
                      bg: "white",
                      round: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("remove-step", step)
                      }
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "text-center step-name" }, [
                step.stepType === _vm.stepTypes.PROVIDER
                  ? _c("div", [
                      _c("b", [_vm._v(_vm._s(step.data.extra.empresa.razon))]),
                      _c("div", [
                        _vm._v(" " + _vm._s(step.data.extra.empresa.iut) + " ")
                      ])
                    ])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.EXTERNAL
                  ? _c("div", [
                      _c("div", [
                        _vm._v(" " + _vm._s(step.data.responsable.rut) + " ")
                      ])
                    ])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.PERSON
                  ? _c("div", [_vm._v(" " + _vm._s(step.responsibleIut) + " ")])
                  : _vm._e(),
                _vm._v(" " + _vm._s(step.responsibleName) + " "),
                step.stepType === _vm.stepTypes.PERSON
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: step.responsibleEmail,
                            expression: "step.responsibleEmail"
                          }
                        ],
                        staticClass: "text-truncate"
                      },
                      [_vm._v(" " + _vm._s(step.responsibleEmail) + " ")]
                    )
                  : _vm._e(),
                step.stepType === _vm.stepTypes.GROUP
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: "Integrantes del grupo",
                            expression: "'Integrantes del grupo'"
                          }
                        ]
                      },
                      [_vm._v(" (" + _vm._s(step.groupUsers.length) + ") ")]
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "step-type" }, [
                step.distributed
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value:
                              "Distribuido: se asigna a 1 persona del grupo secuencialmente",
                            expression:
                              "'Distribuido: se asigna a 1 persona del grupo secuencialmente'"
                          }
                        ],
                        staticClass: "mr-1"
                      },
                      [
                        _c("vs-icon", {
                          attrs: {
                            icon: "share",
                            size: "12px",
                            color: "warning"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                step.stepType === _vm.stepTypes.USER
                  ? _c("span", [_vm._v(" usuario ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.GROUP
                  ? _c("span", [_vm._v(" grupo ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.PROVIDER
                  ? _c("span", [_vm._v(" proveedor ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.OFFICE
                  ? _c("span", [_vm._v(" oficina ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.PERSON
                  ? _c("span", [_vm._v(" persona ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.EXTERNAL
                  ? _c("span", [_vm._v(" externo ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.COMPLETION
                  ? _c("span", [_vm._v(" completitud ")])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "step-rol" }, [
                step.rolType === _vm.rolTypes.CONFIGURATOR
                  ? _c("span", [_vm._v(" configurador ")])
                  : _vm._e(),
                step.rolType === _vm.rolTypes.APPROVER
                  ? _c("span", [_vm._v(" aprobador ")])
                  : _vm._e(),
                step.rolType === _vm.rolTypes.SIGNER &&
                step.stepType !== _vm.stepTypes.OFFICE
                  ? _c("span", [_vm._v(" firmante ")])
                  : _vm._e(),
                step.rolType === _vm.rolTypes.REVIEWER
                  ? _c("span", [_vm._v(" revisor ")])
                  : _vm._e(),
                step.stepType === _vm.stepTypes.OFFICE &&
                step.rolType === _vm.rolTypes.SIGNER
                  ? _c("span", [_vm._v(" num/tramitar ")])
                  : _vm._e()
              ])
            ])
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }